export const NOTIFICATIONS_API_BASE_PATH = "/api/layout-user/notifications";
export const NOTIFICATIONS_KEY_PREFIX = "notifications";
export const PAGE_SIZE = 10;
//# sourceMappingURL=constants.js.map